module.exports = __webpack_public_path__ + "img/Cori_Plug.ce85c0f7.png";